import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "seq-tabs seq-tabs--underline mb-6" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Estore ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Transfer Product ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Estore Transactions ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Vote for Miss iGlow ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/estore",
      class: "seq-tabs__link",
      "active-class": "active"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (_ctx.isBCOAccount)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/transferproduct",
          class: "seq-tabs__link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isBCOAccount)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: "/estoretrans",
          class: "seq-tabs__link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.votingON == true)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          to: "/votemsiglow",
          class: "seq-tabs__link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}